import {BaseCaller} from './api';
import {DriverStateDTO} from './model';

export default class DriverApi {

    private caller: BaseCaller;

    constructor(caller: BaseCaller) {
        this.caller = caller;
    }

    public list(): Promise<any> {
        return this.caller.get('driver/');
    };

    public listAvailable(): Promise<any> {
        return this.caller.get('driver/getAvailable');
    };

    public listActiveByAdmin(): Promise<any> {
        return this.caller.get('driver/active/byAdmin');
    };

    save(data: any) {
        if (data.driver.id) {
            console.log('put', data);
            return this.caller.put(`driver/${data.driver.id}`, data);
        }
        console.log('post', data);
        return this.caller.post('driver/', data);

    }

    disable(id: string) {
        return this.caller.post(`driver/${id}/inactivate`, {});
    }

    location(id: number): Promise<DriverStateDTO> {
        return this.caller.get(`driver/${id}/location`);
    }

    locations(): Promise<DriverStateDTO[]> {
        return this.caller.get(`driver/locations`);
    }

}




// WEBPACK FOOTER //
// ./src/api/driver-api.ts